import { render } from "./page9.vue?vue&type=template&id=61988235&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"

import "./page9.vue?vue&type=style&index=0&id=61988235&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61988235"]])

export default __exports__